import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when two-factor authentication popup was closed.
 * @memberOf Playtech.API.events
 * @event TWO_FA_POPUP_CLOSED
 * @type {callback}
 * @param {string[]} details details[0] is component
 * @example Playtech.on('TWO_FA_POPUP_CLOSED', ([Component]) => { ... });
 */
export const TWO_FA_POPUP_CLOSED = 'TWO_FA_POPUP_CLOSED';

export const useOn2FAPopupClosed = (eventTarget) => {
    const trigger2FAPopupClosedEvent = useCallback((...component) => {
        const popupClosed = new CustomEvent(TWO_FA_POPUP_CLOSED, { detail: component });

        eventTarget.dispatchEvent(popupClosed);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('2fa-popup-closed', trigger2FAPopupClosedEvent);

        return () => {
            publicEventsAPIService.off('2fa-popup-closed', trigger2FAPopupClosedEvent);
        };
    }, [trigger2FAPopupClosedEvent]);
};
